module.exports = __webpack_public_path__ + "2849a75ac48ae4afd3bf90ae0576869f.svg";